import MuiCard, { type CardProps as MuiCardProps } from '@mui/material/Card'
import MuiCardContent, { type CardContentProps as MuiCardContentProps } from '@mui/material/CardContent'
import MuiCardMedia, { type CardMediaProps as MuiCardMediaProps } from '@mui/material/CardMedia'

//* CARD
export const Card = MuiCard
export type CardProps = MuiCardProps

//* CARD CONTENT
export const CardContent = MuiCardContent
export type CardContentProps = MuiCardContentProps

//* CARD MEDIA
export const CardMedia = MuiCardMedia
export type CardMediaProps = MuiCardMediaProps
